import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  setViewOptionsDownloadInLot: ['value'],
});

const INITIAL_STATE = {
  viewOptions: false
};

const setViewOptionsDownloadInLot = (_state = INITIAL_STATE, action: any) => ({
  viewOptions: action.value,
});


export default createReducer(INITIAL_STATE, {
  [Types.SET_VIEW_OPTIONS_DOWNLOAD_IN_LOT as any]: setViewOptionsDownloadInLot,
});